import { ApiResponse } from "../../types/types";
import request from "../request";
import { feedbackData } from "./types";

export const saveFeedback = async (payload: feedbackData) => {
  return await request.post<ApiResponse>(`/user/customer-survery`, payload);
};
